import { Component, AfterViewInit } from '@angular/core';
import { Http, HttpModule, Headers, RequestOptions } from '@angular/http';
import { UserService } from '../../services/user.service';
import { LinkService } from '../../services/link.service';
import * as _ from 'lodash';
declare var Stripe: any;
declare var fbq: any;

@Component({
  selector: 'page-plans',
  templateUrl: 'plans.html',
})
export class PlansPage {

  userService;
  linkService;
  authUser;
  profile: any;
  displayLinks = [];
  displayLinksSub: any;
  routeId;
  settings;
  noUserAtTime = false;

  elements: any;
  stripe: any;
  style: any;
  card: any;
  form: any;

  deletingCard = false;
  updatingCard = false;
  savingCard = false;
  renewDate: any;

  billingCycle = 'monthly';
  plans: any = {};
  selectedPlan: any;
  invalidCoupon = false;
  couponLoading = false;

  stripeKey;
  stripeBilling: any;
  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  selectedPro = false;

  constructor(
    public http: Http
  ) {
    this.userService = new UserService();
    this.linkService = new LinkService();

    if (!location.origin.includes('localhost')) fbq('trackSingle', '205991469998512', 'Lead');
  }

  async userLoaded(user) {
    if (!user || !user.uid) window.location.href = "/login";
    this.authUser = user;
    if (this.routeId || user) {
      this.settings = await this.userService.getUserSettings(this.routeId || user.uid);
      if (this.noUserAtTime) this.ngAfterViewInit();
      this.profile = await this.userService.getProfile(this.routeId || user.uid);
      this.displayLinksSub = this.linkService.getUserLinksSub(this.routeId || user.uid).onSnapshot((data) => {
        this.displayLinks = [];
        data.forEach((doc) => {
          this.displayLinks.push(doc.data());
        });
        this.displayLinks = _.sortBy(this.displayLinks, 'displayOrder');
      });
    }
  }

  async isValidCoupon() {
    if (!(<HTMLInputElement>document.getElementById('coupon')).value.toLowerCase()) {
      this.invalidCoupon = false;
      return;
    }
    this.couponLoading = true;
    const headers = new Headers();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Credentials', 'true');

    const options = new RequestOptions({headers: headers});
    let isValidSub = this.http.post('https://us-central1-bitl-it.cloudfunctions.net/isValidCoupon', {
        coupon: (<HTMLInputElement>document.getElementById('coupon')).value.toLowerCase() || null
    }, options).subscribe(async (res: any) => {
      let ress = JSON.parse(res._body || res || "{}");
      if (ress && ress.isValid) {
        this.invalidCoupon = false;
      } else {
        this.invalidCoupon = true;
      }
      this.couponLoading = false;
      isValidSub.unsubscribe();
    })
  }

  setRenewDate() {
    if (this.settings && this.settings.stripeSubscription && this.settings.stripeSubscription.current_period_end) {
      let date = new Date(this.settings.stripeSubscription.current_period_end*1000);
      this.renewDate = `${this.months[date.getUTCMonth()]} ${date.getUTCDate()}, ${date.getUTCFullYear()}`
    }
    if (this.settings && this.settings.stripeSubscription && this.settings.stripeSubscription && this.settings.stripeSubscription.plan.amount > 600) {
      this.billingCycle = 'yearly';
    }
  }

  timeoutNgAfterViewInit() {
    setTimeout(() => {
      this.ngAfterViewInit();
    }, 600)
  }

  ngAfterViewInit() {
    if (!this.authUser) {
      this.noUserAtTime = true;
      return;
    }
    if (!document.getElementById('card-element')) return;
    this.plans = {
      monthly: location.origin.includes('localhost') ? 'plan_Cm2p2Nu5cQXOeK' : 'plan_CkQDY0P9DeUrfB',
      yearly: location.origin.includes('localhost') ? 'plan_Cm6t8tPUsJDa0w' : 'plan_Cm6vPRWeo6ETJr',
    }
    this.selectedPlan = this.plans.monthly;
    this.stripeKey = location.origin.includes('localhost') ? 'pk_test_GmvKWChqlZl4KYqrHZVgAdqN' : 'pk_live_j9qWqiZoNX94SsiP0V7c1HSj'
    // Create a Stripe client.
    this.stripe = Stripe(this.stripeKey);
    // this.stripeBilling = stripeBilling('pk_live_j9qWqiZoNX94SsiP0V7c1HSj');


    // Create an instance of Elements.
    this.elements = this.stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    this.style = {
      base: {
        color: '#32325d',
        lineHeight: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    // Create an instance of the card Element.
    this.card = this.elements.create('card', {style: this.style});

    // Add an instance of the card Element into the `card-element` <div>.
    this.card.mount('#card-element');

    // Handle real-time validation errors from the card Element.
    this.card.addEventListener('change', (event) => {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
      if (!location.origin.includes('localhost')) fbq('trackSingle', '205991469998512', 'InitiateCheckout')
    });

    // Handle form submission.
    this.form = document.getElementById('payment-form');
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.savingCard = true;
      this.stripe.createToken(this.card).then((result) => {
        if (result.error) {
          // Inform the user if there was an error.
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
          this.savingCard = false;
        } else {
          // Send the token to your server.
          this.userService.stripeTokenHandler(result.token, this.authUser.uid);
          const headers = new Headers();
          headers.append('Access-Control-Allow-Origin', '*');
          headers.append('Access-Control-Allow-Credentials', 'true');
          this.savingCard = true;

          const options = new RequestOptions({headers: headers});
          if (!this.settings.stripeCustomer) {
            let responseCustomerSub = this.http.post('https://us-central1-bitl-it.cloudfunctions.net/createStripeCustomer', {
              test: !!location.origin.includes('localhost'),
              customer: {
                email: this.profile.email || '',
                description: this.profile.name || '',
                source: result.token.id // obtained with Stripe.js
              }
            }, options).subscribe((r: any) => {
              if (!location.origin.includes('localhost')) fbq('trackSingle', '205991469998512', 'AddPaymentInfo');
              let customer = JSON.parse(r._body || "{}");
              this.userService.stripeCustomerHandler(customer, this.authUser.uid);
              this.userService.stripePlanHandler(this.plans[this.billingCycle], this.authUser.uid);
              let planUpdateSub = this.http.post('https://us-central1-bitl-it.cloudfunctions.net/updateCustomerPlan', {
                test: !!location.origin.includes('localhost'),
                customerId: customer.id,
                planId: this.plans[this.billingCycle],
                coupon: (<HTMLInputElement>document.getElementById('coupon')).value.toLowerCase() || null
              }, options).subscribe(async (res: any) => {
                let subscription = JSON.parse(res._body || res || "{}")
                this.userService.stripeSubscriptionHandler(subscription, this.authUser.uid)
                this.settings = await this.userService.getUserSettings(this.authUser.uid);
                if (!location.origin.includes('localhost')) fbq('trackSingle', '205991469998512', 'Purchase');
                this.setRenewDate();
                this.savingCard = false;
                responseCustomerSub.unsubscribe();
                planUpdateSub.unsubscribe();
              })
            })
          } else {
            let responseCustomerSub = this.http.post('https://us-central1-bitl-it.cloudfunctions.net/updateCustomerCard', {
              test: !!location.origin.includes('localhost'),
              customerId: this.settings.stripeCustomer.id,
              oldCardId: this.settings.stripePayment.card.id,
              newCardId: result.token.id // obtained with Stripe.js
            }, options).subscribe((r: any) => {
              let customer = JSON.parse(r._body || "{}");
              this.userService.stripeCustomerHandler(customer, this.authUser.uid);
              this.userService.stripePlanHandler(this.plans[this.billingCycle], this.authUser.uid);
              let planUpdateSub = this.http.post('https://us-central1-bitl-it.cloudfunctions.net/updateCustomerPlan', {
                test: !!location.origin.includes('localhost'),
                customerId: customer.id,
                planId: this.plans[this.billingCycle],
                coupon: (<HTMLInputElement>document.getElementById('coupon')).value.toLowerCase() || null
              }, options).subscribe(async (res: any) => {
                let subscription = JSON.parse(res._body || res || "{}")
                this.userService.stripeSubscriptionHandler(subscription, this.authUser.uid)
                this.settings = await this.userService.getUserSettings(this.authUser.uid);
                if (!location.origin.includes('localhost')) fbq('trackSingle', '205991469998512', 'Purchase');
                this.setRenewDate();
                this.savingCard = false;
                this.updatingCard = false;
                responseCustomerSub.unsubscribe();
                planUpdateSub.unsubscribe();
              })
            })
          }
          // this.stripeBilling.customers.create({
          //   email: this.authUser.emailAddress,
          //   source: result.token.id // obtained with Stripe.js
          // }, (err, customer) => {
          //   // asynchronously called
          //   console.log(customer);
          //   this.userService.stripeCustomerHandler(customer, this.authUser.uid);
          // });
        }
      });
    });
  }

  subscribeCurrentUser() {
    const headers = new Headers();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Credentials', 'true');
    this.savingCard = true;

    const options = new RequestOptions({headers: headers});
    let planUpdateSub = this.http.post('https://us-central1-bitl-it.cloudfunctions.net/updateCustomerPlan', {
      test: !!location.origin.includes('localhost'),
      customerId: this.settings.stripeCustomer.id,
      planId: this.plans[this.billingCycle],
      coupon: (<HTMLInputElement>document.getElementById('coupon')).value.toLowerCase() || null
    }, options).subscribe(async (res: any) => {
      this.userService.stripePlanHandler(this.plans[this.billingCycle], this.authUser.uid);
      let subscription = JSON.parse(res._body || res || "{}")
      this.userService.stripeSubscriptionHandler(subscription, this.authUser.uid)
      this.settings = await this.userService.getUserSettings(this.authUser.uid);
      this.setRenewDate();
      this.savingCard = false;
      planUpdateSub.unsubscribe();
    })
  }

  async cancelSubscription() {
    this.deletingCard = true;
    const headers = new Headers();
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Credentials', 'true');
    const options = new RequestOptions({headers: headers});
    let responseCustomerSub = this.http.post('https://us-central1-bitl-it.cloudfunctions.net/cancelSubscription', {
      test: !!location.origin.includes('localhost'),
      subId: this.settings.stripeSubscription.id
    }, options).subscribe(async (res: any) => {
      this.deletingCard = false;
      this.userService.cancelSubscription(this.authUser.uid);
      this.settings = await this.userService.getUserSettings(this.authUser.uid);
      responseCustomerSub.unsubscribe();
    })
  }

  updateCard() {
    this.updatingCard = true;
    setTimeout(() => {this.ngAfterViewInit()}, 600);
  }

}



// WEBPACK FOOTER //
// ./src/pages/plans/plans.ts